<section class="complete-section">

  <!-- ── LIST VIEW ──────────────────────────────────── -->
  <ng-container *ngIf="currentView === 'list'">

    <!-- Header -->
    <div class="header-section d-flex justify-content-between align-items-center">
      <span class="header-text">Pages</span>
      <button class="icon-btn" (click)="closeTab()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Pages list -->
    <div cdkDropList class="list-pages" (cdkDropListDropped)="drop($event)">
      <ng-container *ngFor="let page of navButton; let i = index">
        <div cdkDragLockAxis="y" cdkDrag class="drag-navbar">
          <div class="page-row d-flex justify-content-between align-items-center">
            <div class="page-left d-flex align-items-center gap-2"
              (click)="!page.hasOwnProperty('folder') ? pageAction('changePage', page.pageId, page.label) : openFolderPanel('updateFolder', page.folder)">
              <svg class="drag-handle" cdkDragHandle xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                viewBox="0 0 24 24" fill="currentColor">
                <circle cx="9" cy="5" r="1" />
                <circle cx="9" cy="12" r="1" />
                <circle cx="9" cy="19" r="1" />
                <circle cx="15" cy="5" r="1" />
                <circle cx="15" cy="12" r="1" />
                <circle cx="15" cy="19" r="1" />
              </svg>
              <span class="page-name fw-bold">{{page.label}}</span>
            </div>
            <div class="page-actions d-flex align-items-center gap-1">
              <button class="icon-btn"
                (click)="openPageSetting(page.hasOwnProperty('folder') ? page.folder.folderId : page.pageId, page.hasOwnProperty('folder') ? 'FOLDER' : 'PAGE')">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
              <button class="icon-btn" [matMenuTriggerFor]="menu">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="5" r="1" />
                  <circle cx="12" cy="12" r="1" />
                  <circle cx="12" cy="19" r="1" />
                </svg>
              </button>
              <mat-menu #menu>
                <div class="menu-item" (click)="pageAction('addPage',page.pageId,'', 0)"
                  *ngIf="!page.hasOwnProperty('folder')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                  </svg>
                  Duplicate
                </div>
                <div class="menu-item menu-item--danger" *ngIf="!showDeleteOption(page.label)"
                  (click)="!page.hasOwnProperty('folder') ? pageAction('deletePage', page.pageId) : deleteFolder(page.folder.folderId)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path
                      d="m19 7-.8673 12.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224c-1.04928 0-1.92016-.8109-1.99492-1.8575L5 7" />
                    <path d="M10 11v6M14 11v6M4 7h16" />
                    <path d="M9 7V4c0-.55228.44772-1 1-1h4c.5523 0 1 .44772 1 1v3" />
                  </svg>
                  Delete
                </div>
              </mat-menu>
            </div>
          </div>

          <!-- Folder child pages -->
          <div *ngIf="page?.folder?.pages?.length" cdkDropList [cdkDropListData]="page.folder.pages"
            (cdkDropListDropped)="drop1($event, page.folder.pages)">
            <div *ngFor="let folderPage of page.folder.pages" cdkDrag
              class="folder-page-row d-flex justify-content-between align-items-center">
              <div class="page-left d-flex align-items-center gap-2"
                (click)="pageAction('changePage', folderPage.pageId, folderPage.label)">
                <div class="folder-connector">
                  <span></span>
                </div>
                <span class="page-name">{{folderPage.label}}</span>
              </div>
              <div class="page-actions d-flex align-items-center gap-1">
                <button class="icon-btn" (click)="openPageSetting(folderPage.pageId, 'PAGE')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path
                      d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                </button>
                <button class="icon-btn" [matMenuTriggerFor]="folderPageMenu">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="5" r="1" />
                    <circle cx="12" cy="12" r="1" />
                    <circle cx="12" cy="19" r="1" />
                  </svg>
                </button>
                <mat-menu #folderPageMenu>
                  <div class="menu-item" (click)="pageAction('addPage',folderPage.pageId,'', 0)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                    </svg>
                    Duplicate
                  </div>
                  <div class="menu-item menu-item--danger" *ngIf="page.pageName != 'Home'"
                    (click)="deletePage(page.folder.folderId, folderPage.pageId)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path
                        d="m19 7-.8673 12.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224c-1.04928 0-1.92016-.8109-1.99492-1.8575L5 7" />
                      <path d="M10 11v6M14 11v6M4 7h16" />
                      <path d="M9 7V4c0-.55228.44772-1 1-1h4c.5523 0 1 .44772 1 1v3" />
                    </svg>
                    Delete
                  </div>
                </mat-menu>
              </div>
            </div>
          </div>

        </div>
      </ng-container>
    </div>

    <!-- Bottom action buttons -->
    <div class="bottom-section d-flex gap-2">
      <!-- <button class="btn-ghost" (click)="showAddPageModal = true; newPageName = ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 5v14M5 12h14" />
        </svg>
        New Page
      </button> -->
      <button class="btn-ghost" (click)="createFolder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
          <path d="M12 11v6M9 14h6" />
        </svg>
        New Folder
      </button>
    </div>

    <!-- Add New Page Modal -->
    <div class="page-modal-overlay" *ngIf="showAddPageModal" (click)="showAddPageModal = false">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header d-flex justify-content-between align-items-center">
          <span class="modal-title">Add New Page</span>
          <button type="button" class="icon-btn" (click)="showAddPageModal = false">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="modal-body px-4 py-3">
          <label class="modal-label">Page Name</label>
          <input type="text" class="modal-input" placeholder="Enter page name" [(ngModel)]="newPageName" />
        </div>
        <div class="modal-footer d-flex justify-content-end gap-2 px-4 py-3">
          <button type="button" class="btn-modal-cancel" (click)="showAddPageModal = false">Cancel</button>
          <button type="button" class="btn-modal-confirm" (click)="showAddPageModal = false; pageAction('addPage')">Save
            Page</button>
        </div>
      </div>
    </div>

  </ng-container>

  <!-- ── FOLDER FORM VIEW ───────────────────────────── -->
  <ng-container *ngIf="currentView === 'folder-form'">

    <div class="header-section d-flex align-items-center">
      <span class="breadcrumb-link" (click)="returnToList()">Pages</span>
      <svg class="breadcrumb-sep" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5">
        <path d="m8.25 4.5 7.5 7.5-7.5 7.5" />
      </svg>
      <span class="breadcrumb-current">{{ folderMode === 'addFolder' ? 'Create Folder' : 'Edit Folder' }}</span>
    </div>

    <div class="folder-form-body">
      <p class="folder-form-label">Label</p>
      <input type="text" class="folder-form-input" [(ngModel)]="folderFormData.folderName" placeholder="Folder name">
      <p class="folder-form-desc">This is the word shown in navigation.</p>
    </div>

    <div class="folder-form-footer" *ngIf="folderFormData.folderName !== folderOriginalName">
      <button class="btn-discard" (click)="returnToList()">Discard</button>
      <button class="btn-save" (click)="saveFolderForm()">Save</button>
    </div>

  </ng-container>

</section>